var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@1xCurrent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5, 1)",
    fill: "#1991DC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42857143,6 L3.14285714,6 L3.14285714,27 L18.8571429,27 L18.8571429,6 L12.5714286,6 L12.5714286,3 L9.42857143,3 L9.42857143,6 Z M6.28571429,3 L6.28571429,1.5 C6.28571429,0.67158 6.98927429,0 7.85714286,0 L14.1428571,0 C15.0107571,0 15.7142857,0.67158 15.7142857,1.5 L15.7142857,3 L20.4285714,3 C21.2964714,3 22,3.67158 22,4.5 L22,28.5 C22,29.32845 21.2964714,30 20.4285714,30 L1.57142857,30 C0.70356,30 0,29.32845 0,28.5 L0,4.5 C0,3.67158 0.70356,3 1.57142857,3 L6.28571429,3 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 15,
    x2: 16,
    y2: 25,
    id: "Line",
    stroke: "#1991DC",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#1991DC",
    points: "16 8 20 16 12 16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrent);
export default __webpack_public_path__ + "static/media/Current.d5c94fe16d5743716ec2dae2ef9f7673.svg";
export { ForwardRef as ReactComponent };